import React, { Component } from 'react'
import { Button, Row, Col, Table, Popconfirm, Select, Pagination, Checkbox, Modal } from 'antd'
import PropTypes from 'prop-types'
import { api, app } from "../../app"
import utils from "../../utils"
import _ from "underscore"
import ReviewSearch from "../../components/ReviewSearch"
import common from "./common"

const Option = Select.Option

class ReIdentity extends Component {
    constructor (props) {
        super(props)
        this.state = {
            data_loading: true,
            selectedRowKeys: [],
            auditList: [],
            total: 0,
            page: 1,
            dataType: '1',
            search_type: 'searchform_name',
            search_val: '',
        }
    }

    /**
     * 设置值
     * @param data
     */
    setData = async (data) => app.setStateSync(this, data)

    componentDidMount () {
        this._isMounted = true
        this.dataSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 数据源
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { dataType, search_type, search_val } = this.state, params = {
            page,
            search_val,
            search_type,
            type: dataType,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.UserAuditList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                auditList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            })
        }
    }

    /**
     * 页码修改
     * @param page
     */
    handlePageChange = async (page) => {
        await this.dataSource(page)
    }

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.auditList.length + 1)
        }
        await this.setData({ selectedRowKeys })
    }

    /**
     * 批量审核
     * @param type
     */
    handlePLReview = async (type) => {
        let { selectedRowKeys, auditList, page, total } = this.state, len = selectedRowKeys.length
        if (len === 0) {
            app.alert('请选择审核内容', 'warn')
            return
        }
        let tp = parseInt((total - len) / 20)
        tp = (total - len) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let id = selectedRowKeys.map(index => auditList[index - 1].id).join(',')
        let reviewInfo = {
            id,
            uri: api.StatusAudit,
            id_key: "id",
            source: () => this.dataSource(tp),
        }
        if (type === 1) {
            this.props.successReview(1, "", reviewInfo)
        } else if (type === 2) {
            this.props.failReview(reviewInfo)
        }
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource()
    }

    /**
     * 显示更多信息
     */
    handleShowMore = (info) => {
        Modal.info({
            title: info.vname + '的更多信息',
            centered: true,
            width: '50%',
            content: (
                <div>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>姓名：</Col>
                        <Col span={18}>{info.vname}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>队员编号：</Col>
                        <Col span={18}>{info.bsrno}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>目前状态：</Col>
                        <Col span={18}>{info.now_state || ' - '}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>修改类型：</Col>
                        <Col span={18}>{info.update_type || ' - '}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>修改前：</Col>
                        <Col span={18}>{info.before_state || ' - '}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>修改后：</Col>
                        <Col span={18}>{info.later_state}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>修改信息队伍：</Col>
                        <Col span={18}>{info.teamname}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>加入存心日期：</Col>
                        <Col span={18}>{info.indate}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>加入存心天数：</Col>
                        <Col span={18}>{info.indateDay}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>拥有几项技能：</Col>
                        <Col span={18}>{info.ppeCount || 0}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>服务时长：</Col>
                        <Col span={18}>{info.duration || 0}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>无线电资格证：</Col>
                        <Col span={18}>{info.radio === '1' ? '有' : (info.radio === '3' ? '已过期' : '无')}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>急救证：</Col>
                        <Col span={18}>{info.first_aid === '1' ? '有' : (info.first_aid === '3' ? '已过期' : '无')}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>医师资格证：</Col>
                        <Col span={18}>{info.physician === '1' ? '有' : (info.physician === '3' ? '已过期' : '无')}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>提交时间：</Col>
                        <Col span={18}>{info.update_time}</Col>
                    </Row>
                    <Row style={{ marginBottom: 12 }}>
                        <Col span={6}>修改原因：</Col>
                        <Col span={18}>{info.leave_reason || ' - '}</Col>
                    </Row>
                </div>
            )
        })
    }

    render () {
        let { data_loading, auditList, selectedRowKeys, total, page, dataType } = this.state,
            tp = parseInt((total - 1) / 20)
        tp = (total - 1) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }

        let columns = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '9%'
                },
                {
                    title: '队员编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '9%'
                },
                {
                    title: '目前状态',
                    dataIndex: 'now_state',
                    key: 'now_state',
                    width: '8%',
                    render (text) {
                        return (<span>{text || '暂无'}</span>)
                    }
                },
                {
                    title: '修改类型',
                    dataIndex: 'update_type',
                    key: 'update_type',
                    width: '9%',
                    render (text) {
                        return (<span>{text || '无'}</span>)
                    }
                },
                {
                    title: '修改前',
                    dataIndex: 'before_state',
                    key: 'before_state',
                    width: '10%',
                    render (text) {
                        return (<span>{text || '无'}</span>)
                    }
                },
                {
                    title: '修改后',
                    dataIndex: 'later_state',
                    key: 'later_state',
                    width: '10%'
                },
                {
                    title: '修改信息队伍',
                    dataIndex: 'teamname',
                    key: 'teamname',
                    width: '10%'
                },
                {
                    title: '无线电资格证',
                    dataIndex: 'radio',
                    key: 'radio',
                    width: '10%',
                    render (text) {
                        switch (text) {
                            case '1':
                                return (<span>有</span>)
                            case '3':
                                return (<span>已过期</span>)
                            default:
                                return (<span>无</span>)
                        }
                    }
                },
                {
                    title: '急救证',
                    dataIndex: 'first_aid',
                    key: 'first_aid',
                    width: '10%',
                    render (text) {
                        switch (text) {
                            case '1':
                                return (<span>有</span>)
                            case '3':
                                return (<span>已过期</span>)
                            default:
                                return (<span>无</span>)
                        }
                    }
                },
                {
                    title: '医师资格证',
                    dataIndex: 'physician',
                    key: 'physician',
                    width: '10%',
                    render (text) {
                        switch (text) {
                            case '1':
                                return (<span>有</span>)
                            case '3':
                                return (<span>已过期</span>)
                            default:
                                return (<span>无</span>)
                        }
                    }
                }
            ],
            rowSelection = null
        if (dataType === '1') {
            columns.push({
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                width: '15%',
                render: (id, item) => {
                    let reviewInfo = {
                        id,
                        uri: api.StatusAudit,
                        id_key: "id",
                        source: () => this.dataSource(tp),
                    }
                    let disabled = selectedRowKeys.length > 1
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <div>
                                <Popconfirm placement="bottom"
                                            title="确定审核通过吗？"
                                            cancelText="取消"
                                            okText="确定"
                                            onConfirm={async () => {
                                                this.props.successReview(1, "", reviewInfo)
                                            }}
                                >
                                    <Button size="small" type="primary" disabled={disabled}>通过</Button>
                                </Popconfirm>
                            </div>
                            <div>
                                <Button size="small" type="danger" onClick={() => {
                                    this.props.failReview(reviewInfo)
                                }} disabled={disabled} ghost style={{ margin: '10px 0' }}>不通过</Button>
                            </div>
                            <div>
                                <Button size="small" onClick={() => {
                                    this.handleShowMore(item)
                                }}>更多信息</Button>
                            </div>
                        </div>
                    )
                }
            })
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys })
                }
            }
        } else {
            columns[0].width = '8%' //1
            columns[1].width = '8%' //1
            columns[4].width = '8%' //2
            columns[5].width = '9%' //1
            columns[8].width = '8%' //2 63 37 22 15
            columns.push({
                title: '管理员审核',
                dataIndex: 'admin_audit',
                key: 'admin_audit',
                width: '12%',
                render: (audit, { admin_name, admin_time, detail }) => common.tableStatus(audit, admin_name, admin_time, detail)
            }, {
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                width: 120,
                render: (id, item) => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <Button size="small" onClick={() => {
                                this.handleShowMore(item)
                            }}>更多信息</Button>
                        </div>
                    )
                }
            })
        }
        return (
            <div style={{ height: '100%' }}>
                <div>
                    <span>审核状态： </span>
                    <Select defaultValue="1" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataType: value })
                        await this.dataSource()
                    }}>
                        <Option value="1">未审核</Option>
                        <Option value="2">已审核</Option>
                    </Select>
                    <ReviewSearch onSearch={this.handleSearch}/>
                    {/*<p style={{color:'red',marginBottom:5}}>【志愿者】身份不设存心编号，身份修改为【志愿者】的队员，原来的存心编号将被清空!</p>*/}
                </div>
                <Table columns={columns}
                       locale={app.tbLocale(data_loading)}
                       dataSource={auditList}
                       loading={data_loading}
                       scroll={{ y: 'calc(100% - 103px)' }}
                       style={{ height: 'calc(100% - 52px)' }}
                       rowSelection={rowSelection}
                       pagination={false}
                       footer={() => {
                           return (
                               <Row hidden={auditList.length === 0}>
                                   <Col span={10}>
                                       <div hidden={dataType === '2'}>
                                           <Checkbox
                                               checked={auditList.length !== 0 && auditList.length === selectedRowKeys.length}
                                               onChange={this.handleAllSel}>全选</Checkbox>
                                           <Button style={{ margin: '0 20px' }} type="primary"
                                                   onClick={() => this.handlePLReview(1)}>通过</Button>
                                           <Button type="danger" onClick={() => this.handlePLReview(2)}>不通过</Button>
                                       </div>
                                   </Col>
                                   <Col span={14} style={{ textAlign: 'right' }}>
                                       <Pagination total={total} size="small" pageSize={20} current={page}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handlePageChange}/>
                                   </Col>
                               </Row>
                           )
                       }}
                       size="small"
                />
            </div>
        )
    }
}

ReIdentity.propTypes = {
    successReview: PropTypes.func.isRequired,   //审核通过处理
    failReview: PropTypes.func.isRequired,  //审核失败处理
}

export default ReIdentity



// WEBPACK FOOTER //
// ./src/routes/review/ReIdentity.jsx